export default [
  // these are here to create route aliases to improve URLS for user dashboard
  { path: "/user", redirect: { name: "user-dashboard-profile" } },
  { path: "/user/dashboard", redirect: { name: "user-dashboard-profile" } },
];
